const en: Record<string, string> = {
  // === LandingPage ===
  'diceIcon': 'Dice Coin',
  'gameTitle': 'Farkle Dice',
  'playerBalance': 'Balance: {amount} Groschen',
  'startGame': 'Start Game',
  'challengers': 'Challengers',
  'diceCollection': 'Dice Collection',
  'diceShop': 'Dice Shop',
  'gameSettings': 'Game Settings',
  'back': 'Back',
  'footerContact': 'Add WeChat: cavi06 to join the community',

  // === ChallengerSelector ===
  'selectChallenger': 'Select Challenger',
  'challengerSubtitle': 'Defeat a challenger to win the bet and a chance to get their special dice as a reward!',
  'yourGroschen': 'Your Groschen: ',
  'targetScore': 'Target Score:',
  'betAmount': 'Bet Amount:',
  'insufficientFunds': 'Not enough Groschen!',
  'startChallenge': 'Start Challenge',

  // === GameControls ===
  'opponentActing': 'Opponent is playing...',
  'rollDice': 'Roll Dice',
  'scoreAndReroll': 'Score & Reroll',
  'scoreAndEndTurn': 'Score & End Turn',
  'endTurn': 'End Turn',
  'playAgain': 'Play Again',

  // === ScoreBoard ===
  'score': 'Score',
  'computer': 'Computer',
  'currentTurn': 'Current Turn',

  // === GameSettings ===
  'computerDifficulty': 'Computer Difficulty',
  'easy': 'Easy (Target: 2000)',
  'medium': 'Medium (Target: 4000)',
  'hard': 'Hard (Target: 10000)',
  'language': 'Language',
  'langZh': '中文',
  'langEn': 'English',
  'save': 'Save',
  'cancel': 'Cancel',

  // === GameRules ===
  'gameRules': 'Game Rules',
  'farkleRules': 'Farkle Game Rules',
  'welcomeTitle': 'Welcome to Farkle Dice',
  'welcomeText': 'This is a Farkle game entirely written by AI. There may still be some bugs, and the visual experience is still being improved. Thank you for your patience.',
  'contactText': 'If you find any bugs or have suggestions, please contact me on WeChat: mzz0606.',
  'gameObjectiveTitle': 'Game Objective',
  'gameObjectiveText': 'Be the first player to reach the target score (default 4,000 points).',
  'bettingRulesTitle': 'Betting Rules',
  'bettingRulesText1': 'At the start of each game, players can bet Groschen. The bet amount is immediately deducted from the player\'s balance.',
  'bettingRulesText2': 'If the player wins, they receive double the bet amount (net gain equals the bet); if the computer wins, the player loses the bet.',
  'bettingRulesText3': 'Players start with 50 Groschen. If you run out, you can bet 0 Groschen to earn special dice and sell them to get back on your feet.',
  'gameFlowTitle': 'Gameplay',
  'gameFlowText': 'Players take turns rolling dice and collecting points. Each turn, a player rolls six dice and must select at least one valid scoring combination.',
  'scoringCombosTitle': 'Scoring Combinations',
  'scoringSingle1': 'Single 1 = 100 points',
  'scoringSingle5': 'Single 5 = 50 points',
  'scoringTriple1': 'Three 1s = 1,000 points',
  'scoringTriple2': 'Three 2s = 200 points',
  'scoringTriple3': 'Three 3s = 300 points',
  'scoringTriple4': 'Three 4s = 400 points',
  'scoringTriple5': 'Three 5s = 500 points',
  'scoringTriple6': 'Three 6s = 600 points',
  'scoringFourOfKind': 'Four of a kind = 2x three of a kind score',
  'scoringFiveOfKind': 'Five of a kind = 4x three of a kind score',
  'scoringSixOfKind': 'Six of a kind = 8x three of a kind score',
  'scoringSmallStraight': '1-2-3-4-5 (Small Straight) = 500 points',
  'scoringLargeStraight': '2-3-4-5-6 (Large Straight) = 750 points',
  'scoringFullStraight': '1-2-3-4-5-6 (Full Straight) = 1,500 points',
  'farkleTitle': 'Farkle (No Score)',
  'farkleText': 'If a player rolls the dice and has no valid scoring combination, it\'s called a "Farkle". The player loses all accumulated points for the current turn, and their turn ends.',
  'turnEndTitle': 'End of Turn',
  'turnEndText': 'Players can choose to "Bank & End Turn" to save their current turn score, or continue rolling remaining dice for more points (but with greater risk).',
  'gameEndTitle': 'Game Over',
  'gameEndText': 'The game ends when a player reaches the target score.',
  'close': 'Close',

  // === DiceShop ===
  'buyDice': 'Buy Dice',
  'sellDice': 'Sell Dice',
  'availableGroschen': 'Available Groschen:',
  'insufficientGroschenBuy': 'Not enough Groschen to purchase',
  'maxOwnedReached': 'Max quantity of {name} reached ({max})',
  'cannotSellInUse': 'Cannot sell dice currently in use',
  'purchaseSuccess': 'Successfully purchased {name}',
  'sellSuccess': 'Successfully sold {name}, received {amount} Groschen',
  'owned': 'Owned: {count}/{max}',
  'maxReached': ' (Max reached)',
  'groschen': 'G',
  'maxReachedBtn': 'Max Reached',
  'buy': 'Buy',
  'sellNote': 'Selling dice returns 70% of the original price. Dice currently in use cannot be sold.',
  'ownedCount': 'Owned: {count} (Using {used})',
  'noSellableDice': 'You have no dice to sell',
  'inUse': 'In Use',
  'sell': 'Sell',
  'confirmPurchase': 'Confirm Purchase',
  'confirmSell': 'Confirm Sale',
  'confirmBuyText': 'Are you sure you want to buy {name}? Price: {price} Groschen',
  'confirmSellText': 'Are you sure you want to sell {name}? You will receive {amount} Groschen.',

  // === DiceSelector ===
  'selectDice': 'Select Dice',
  'onlyOwned': 'You only own {count} {name}, all in use',
  'configSaved': 'Dice configuration saved!',
  'selectDiceCombo': 'Select Dice Combination',
  'used': 'Used {used}/{total}',

  // === GameModal ===
  'confirm': 'Confirm',
  'ok': 'OK',

  // === RewardDiceModal ===
  'congratsSpecialDice': 'Special Dice Obtained!',
  'congratsText': 'Congratulations! You got a special die!',
  'rewardMessage': 'This special die has been added to your collection and can be used in the dice selector.',
  'awesome': 'Awesome!',

  // === Game.tsx ===
  'player': 'Player',
  'forfeit': 'Forfeit',
  'playerTotalScore': 'Player Total',
  'opponentTotalScore': '{name} Total',
  'turnScore': 'Turn Score',
  'selectionScore': 'Selection',
  'selectToKeep': 'Select dice to keep.',
  'invalidSelection': 'Current selection has no score value.',
  'pleaseSelect': 'Please select dice to keep.',
  'invalidSelectRetry': 'Invalid selection, please select a valid dice combination',
  'computerRolling': 'Computer is rolling...',
  'computerThinking': 'Computer is thinking... selected {count} dice',
  'endTurnMsg': '{name} ends turn, scored {turnScore} points, total {totalScore}...',
  'selectionScoreMsg': 'Selection: {selection}, Turn score: {turn}',
  'forfeitTitle': 'Confirm Forfeit',
  'forfeitContent': 'Are you sure you want to forfeit?\nYou will lose your bet of {bet} Groschen.',
  'gameOver': 'Game Over',
  'playerWins': '{name} wins!',
  'wonGroschen': '\nYou won {amount} Groschen!',
  'currentGroschen': '\nYou currently have {amount} Groschen.',
  'lostGroschen': '\nYou lost {amount} Groschen.',
  'defeatedChallenger': '\nYou defeated {name} and won {amount} Groschen!',
  'gotSpecialDice': '\nYou got their special die: {name}!',
  'congratsDefeat': '\nCongratulations! You defeated {name}!',
  'challengerWins': '{name} wins! Better luck next time!\n',
  'challengerLostGroschen': 'You lost {amount} Groschen.',
  'insufficientGroschenChallenge': 'Not enough Groschen to challenge {name}! Need {amount} Groschen.',

  // === BettingPanel ===
  'placeBet': 'Place Bet',
  'currentGroschenLabel': 'Current Groschen: {amount}',
  'easyMode': 'Easy Mode',
  'mediumMode': 'Medium Mode',
  'hardMode': 'Hard Mode',
  'betLimit': 'Bet limit: {max} Groschen',
  'betAmountLabel': 'Bet Amount (0-{max})',
  'confirmBet': 'Confirm Bet',

  // === DiceCollection ===
  'toCollect': 'Uncollected',
  'probabilityOf': '{name} Probabilities:',
  'point': '{num}: {prob}%',
  'maxOwnedLabel': 'Max owned: {max}',
  'collectionComplete': 'Collection complete! Click dice to view details',
  'continueCollecting': 'Keep collecting dice to complete the set',
  'collected': '{count}/{total} collected',
  'noSetsUnlocked': 'No dice sets unlocked yet. Keep collecting dice to unlock hidden sets!',

  // === useDiceShop hook ===
  'insufficientGroschenTitle': 'Insufficient Groschen',
  'insufficientGroschenContent': 'You don\'t have enough Groschen to buy this die. Need {price} Groschen.',
  'maxQuantityTitle': 'Max Quantity Reached',
  'maxQuantityContent': 'You already own the maximum quantity ({max}) of this die.',

  // === Dice Names ===
  'dice.NORMAL.name': 'Normal',
  'dice.NORMAL.desc': 'Standard six-sided die with equal probability for each number',
  'dice.CAVIER_1.name': 'Cavier\'s Test 1',
  'dice.CAVIER_1.desc': 'This die... seems to have a bug',
  'dice.CAVIER_2.name': 'Cavier\'s Test 2',
  'dice.CAVIER_2.desc': 'This die... seems to have a bug',
  'dice.CAVIER_3.name': 'Cavier\'s Test 3',
  'dice.CAVIER_3.desc': 'This die... seems to have a bug',
  'dice.CAVIER_4.name': 'Cavier\'s Test 4',
  'dice.CAVIER_4.desc': 'This die... seems to have a bug',
  'dice.CAVIER_5.name': 'Cavier\'s Test 5',
  'dice.CAVIER_5.desc': 'This die... seems to have a bug',
  'dice.CAVIER_6.name': 'Cavier\'s Test 6',
  'dice.CAVIER_6.desc': 'This die... seems to have a bug',
  'dice.ADULT.name': 'Lord\'s',
  'dice.ADULT.desc': 'A die dropped by a lord, maybe it has a special effect',
  'dice.EVEN.name': 'Even',
  'dice.EVEN.desc': 'More likely to roll even numbers',
  'dice.ODD.name': 'Odd',
  'dice.ODD.desc': 'More likely to roll odd numbers',
  'dice.HEAVEN.name': 'Kingdom',
  'dice.HEAVEN.desc': 'The legendary Kingdom Die, please don\'t sell it',
  'dice.KNIGHT.name': 'Knight\'s',
  'dice.KNIGHT.desc': 'Symbolizes the honor and loyalty of a knight',
  'dice.LUCKY.name': 'Lucky',
  'dice.LUCKY.desc': 'More likely to roll 1 and 5, limited quantity',
  'dice.SMALL_LUCKY.name': 'Small Lucky',
  'dice.SMALL_LUCKY.desc': 'More likely to roll 1 and 5, limited quantity',
  'dice.MINI.name': 'Mini',
  'dice.MINI.desc': 'Name doesn\'t match appearance, rolls 1 and 6 often',
  'dice.CLOTHED.name': 'Clothed',
  'dice.CLOTHED.desc': 'Rolls 1, 5, 6 often',
  'dice.RIGGED.name': 'Rigged',
  'dice.RIGGED.desc': 'Basic cheating die, rolls 2 often',
  'dice.UNPOPULAR.name': 'Unpopular',
  'dice.UNPOPULAR.desc': 'Disliked by everyone, maybe useful?',
  'dice.UNLUCKY.name': 'Unlucky',
  'dice.UNLUCKY.desc': 'High chance of rolling middle numbers, best not to use it',
  'dice.TRIPLE_THREE.name': 'Trinity',
  'dice.TRIPLE_THREE.desc': '3! 3! 3!',
  'dice.KAVI_C.name': 'Cavi\'s C-Test',
  'dice.KAVI_C.desc': 'Nobody knows what it\'s for',
  'dice.ANTIOCH.name': 'Holy Antioch',
  'dice.ANTIOCH.desc': 'All 6 faces seem to be 3, but there are only 3',
  'dice.LOADED.name': 'Loaded',
  'dice.LOADED.desc': 'The side with 5 has been weighted',
  'dice.ANGEL_AN.name': 'An',
  'dice.ANGEL_AN.desc': 'Angel Trio "An", rolls 6 often',
  'dice.ANGEL_JI.name': 'Ji',
  'dice.ANGEL_JI.desc': 'Angel Trio "Ji", rolls 6 often',
  'dice.ANGEL_LA.name': 'La',
  'dice.ANGEL_LA.desc': 'Angel Trio "La", rolls 6 often',
  'dice.DEMON_LU.name': 'Lu',
  'dice.DEMON_LU.desc': 'Demon Trio "Lu", rolls 6 often',
  'dice.DEMON_XI.name': 'Xi',
  'dice.DEMON_XI.desc': 'Demon Trio "Xi", rolls 6 often',
  'dice.DEMON_FA.name': 'Fa',
  'dice.DEMON_FA.desc': 'Demon Trio "Fa", rolls 6 often',

  // === Challenger Names ===
  'challenger.tou-ge.name': 'Big Bro',
  'challenger.tou-ge.desc': 'Seems to be the least clever one around',
  'challenger.real-gambler.name': 'True Gambler',
  'challenger.real-gambler.desc': 'Gambles till the world goes dark',
  'challenger.dance-boss.name': 'Dance Hall Boss',
  'challenger.dance-boss.desc': 'If you know, you know',
  'challenger.cheater.name': 'The Cheater',
  'challenger.cheater.desc': 'Infamous cheating master',
  'challenger.a-san.name': 'Mr.Three',
  'challenger.a-san.desc': 'He is just Mr.Three',
  'challenger.malcolm.name': 'Malcolm',
  'challenger.malcolm.desc': 'Has some skill, but not much',
  'challenger.merchant.name': 'Merchant from Afar',
  'challenger.merchant.desc': 'A merchant who traveled far, surely has some luck',
  'challenger.small-cavier.name': 'Little Cavi',
  'challenger.small-cavier.desc': 'Unknown skill level',
  'challenger.enhance-a-san.name': 'Enhanced Mr.Three',
  'challenger.enhance-a-san.desc': 'Still loves the number three',
  'challenger.heaven-knight.name': 'Kingdom Knights',
  'challenger.heaven-knight.desc': 'Wields dice from the Kingdom',
  'challenger.alonso.name': 'Lord Alonso',
  'challenger.alonso.desc': 'The legendary Lord Alonso',
  'challenger.cavier.name': 'Cavier',
  'challenger.cavier.desc': 'You cannot defeat him.',
  'challenger.unknown': 'Unknown Challenger',

  // === Dice Sets ===
  'diceSet.cavier-set.name': 'Cavi\'s Test Dice',
  'diceSet.cavier-set.desc': 'If you can collect them all... then you\'re invincible',
  'diceSet.odd-set.name': 'Odd Set',
  'diceSet.odd-set.desc': 'Collect all odd dice',
  'diceSet.even-set.name': 'Even Set',
  'diceSet.even-set.desc': 'Collect all even dice',
  'diceSet.mini-set.name': 'Mini Set',
  'diceSet.mini-set.desc': 'Collect all mini dice',
  'diceSet.clothed-set.name': 'Clothed Set',
  'diceSet.clothed-set.desc': 'The dance hall boss\'s favorite combination',
  'diceSet.rigged-set.name': 'Cheater',
  'diceSet.rigged-set.desc': 'These dice all seem to be rigged...',
  'diceSet.lucky-set.name': 'Lucky Set',
  'diceSet.lucky-set.desc': 'Collect all lucky dice',
  'diceSet.gambler-set.name': 'Angels & Demons',
  'diceSet.gambler-set.desc': 'One thought to become a demon, one thought to become a saint',
  'diceSet.triple-three-set.name': '3! 3! 3!',
  'diceSet.triple-three-set.desc': '3 is the perfect number',
  'diceSet.loaded-set.name': 'Loaded Dice',
  'diceSet.loaded-set.desc': 'Advanced cheating technique',
  'diceSet.heaven-knight-set.name': 'Kingdom Knight',
  'diceSet.heaven-knight-set.desc': 'Represents the honor of the Kingdom',
  'diceSet.adult-set.name': 'Lord',
  'diceSet.adult-set.desc': 'Lord Alonso\'s exclusive dice set',
  'diceSet.low-set.name': 'Mediocre',
  'diceSet.low-set.desc': 'Too tasteless to eat, too wasteful to throw away',

  // === Privacy Policy ===
  'privacyPolicy': 'Privacy Policy',
  'privacyPolicyContent': 'This game (Farkle Dice) respects and protects your privacy.\n\n1. Data Collection\nThis game uses Google Analytics to collect anonymous usage data (such as page views, device type, geographic location, etc.) to improve the gaming experience. We do not collect any personally identifiable information such as your name, email, or phone number.\n\n2. Local Storage\nGame progress, dice collection, Groschen balance, and other game data are stored only in your browser\'s local storage (localStorage) and are never uploaded to any server.\n\n3. Cookies\nGoogle Analytics may use cookies to distinguish users. You can disable cookies through your browser settings.\n\n4. Third-Party Services\nThis game uses the following third-party services:\n- Google Analytics (data analytics)\n- Vercel (web hosting)\n\n5. Children\'s Privacy\nThis game is not directed at children under 13 and does not knowingly collect personal information from children.\n\n6. Policy Updates\nThis privacy policy may be updated from time to time. Updated policies will be posted on this page.\n\nIf you have any questions, please contact us through in-game channels.',
};

export default en;
